import React, { useEffect, useMemo, useState } from "react"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { useDispatch, useSelector } from "react-redux"
import ProviderTransactionListComponent from "components/ProviderReports/Transaction"
import {
  exportProviderTransactions,
  getProviderTransactions,
} from "store/provider-reports/p-report-action"
import {
  getProviderCommodityClassifications,
  getProviderCurrencies,
  getProviderFundCodes,
  getProviderItemCategories,
  getProviderShipments,
  getProviderWarehouses,
} from "store/provider-dashboard/provider-dashboard-action"
import useSearch from "hooks/useSearch"
import useReportColumns from "hooks/useReportColumns"
import { REPORT_COLUMN_KEYS } from "config/reportColumnDefinitions"

const ProviderTransactionList = () => {
  // Meta Title
  document.title = "Transactions"

  const dispatch = useDispatch()

  // Retrieve transactions data from Redux store
  const transactions = useSelector(
    state => state.providerReports.providerTransactions
  )
  // Retrieve export Transaction data from Redux store
  const exportTransaction = useSelector(
    state => state.providerReports.providerExportTransaction
  )
  const [search, setSearch] = useState(null)
  const [pageNumber, setPageNumber] = useState(20)
  const [according, setAccording] = useState({ order: "desc", name: "date" })
  const [advnacedSearch, setAdvancedSearch] = useState({})
  const {
    columns,
    visibleColumns,
    visibleKeys,
    toggleColumn,
    moveColumnToIndex,
  } = useReportColumns(REPORT_COLUMN_KEYS.PROVIDER_TRANSACTION)

  // Updates search value when a new search is performed
  const onSearchHandler = value => {
    setSearch(value)
  }

  // Fetches new data when a page number is clicked
  const onPageClick = link => {
    dispatch(
      getProviderTransactions(
        link.url,
        pageNumber,
        according,
        search,
        advnacedSearch
      )
    )
  }

  // Updates the number of rows displayed based on user selection (e.g., 10, 20, 50)
  const onChangeRowNumber = value => {
    setPageNumber(value)
  }

  // Updates the ordering based on user selection
  const onChangeOrdering = value => {
    if (value.order) {
      setAccording(prev => {
        return { ...prev, order: value.order }
      })
    }
    if (value.name) {
      setAccording(prev => {
        return { ...prev, name: value.name }
      })
    }
  }

  // Custom Search Hook called everytime search updates
  useSearch(
    getProviderTransactions(
      undefined,
      undefined,
      undefined,
      search,
      advnacedSearch
    ),
    search
  )

  // fetch new data based page number or according changes
  useEffect(() => {
    dispatch(
      getProviderTransactions(
        undefined,
        pageNumber,
        according,
        search,
        advnacedSearch
      )
    )
  }, [pageNumber, according])

  // fetch data for filter
  useEffect(() => {
    dispatch(getProviderItemCategories())
    dispatch(getProviderWarehouses())
    dispatch(getProviderCurrencies())
    dispatch(getProviderShipments())
    dispatch(getProviderFundCodes())
    dispatch(getProviderCommodityClassifications())
  }, [])

  // Executes when the advanced search form is submitted
  const onAdvancedSearchSubmit = data => {
    setAdvancedSearch(data)
    dispatch(
      getProviderTransactions(undefined, undefined, undefined, search, data)
    )
  }

  // Trigger export process when Export button is clicked
  const onExportBtnClick = () => {
    dispatch(
      exportProviderTransactions(
        pageNumber,
        according,
        search,
        advnacedSearch,
        visibleKeys
      )
    )
  }

  return (
    <React.Fragment>
      <Breadcrumbs title={"Provider"} breadcrumbItem={"Transactions"} />
      {/* Provider Transaction List component  */}
      <ProviderTransactionListComponent
        data={transactions?.data}
        error={transactions?.error}
        loading={transactions?.loading}
        onSearch={onSearchHandler}
        onChangeRowNumber={onChangeRowNumber}
        onChangeOrdering={onChangeOrdering}
        onAdvancedSearchSubmit={onAdvancedSearchSubmit}
        onExportBtnClick={onExportBtnClick}
        exportTransaction={exportTransaction}
        onPageClick={onPageClick}
        columns={columns}
        visibleColumns={visibleColumns}
        onToggleColumn={toggleColumn}
        onReorder={moveColumnToIndex}
      />
    </React.Fragment>
  )
}

export default ProviderTransactionList
